import { FormattedNumber } from 'react-intl'

import { type ContractDto } from '@b-stock/contract-api-client'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { ContractBidFulfillmentUnit } from './ContractBidFulfillmentUnit'

const ns = 'Offerings.Details.form'

export const ContractEstimatedQuantity = ({
  value,
  contract,
}: {
  value: number
  contract: ContractDto
}) => {
  return (
    <>
      <FormattedNumber value={value} />{' '}
      <ContractBidFulfillmentUnit contract={contract} />
      {'/'}
      <FormattedMessage id={`${ns}.headers.order`} />
    </>
  )
}
